<script setup lang="ts">
  withDefaults(
    defineProps<{ title: string; badge?: string | number | null; open?: boolean; hint?: string; nested?: boolean }>(),
    {
      badge: null,
      open: false,
      hint: undefined,
      nested: false,
    },
  );
</script>

<template>
  <details
    class="group rounded-md"
    :class="nested ? 'border border-[var(--color-gray-02)] bg-[var(--color-white-02)]' : 'bg-[var(--color-white-01)] shadow-sm'"
    :open="open"
  >
    <summary
      class="flex cursor-pointer items-center gap-2 px-4 font-semibold text-[var(--color-gray-07)]"
      :class="nested ? 'py-2 text-xs' : 'py-3 text-sm'"
    >
      <span class="text-[var(--color-gray-04)] transition-transform group-open:rotate-90">›</span>
      <span class="flex-1">{{ title }}</span>
      <span
        v-if="badge !== null && badge !== ''"
        class="max-w-40 truncate rounded-full bg-[var(--color-gray-09)] px-2 py-0.5 text-[10px] font-medium text-[var(--color-gray-06)]"
      >
        {{ badge }}
      </span>
    </summary>
    <div class="flex flex-col gap-3 px-4 pb-4 text-xs text-[var(--color-gray-07)]">
      <p
        v-if="hint"
        class="text-[11px] text-[var(--color-gray-05)]"
      >
        {{ hint }}
      </p>
      <slot />
    </div>
  </details>
</template>
